import React from "react";
import { Navigate, Outlet } from "react-router-dom";

function AdminRoute({ children }) {
    const superuser = localStorage.getItem("superuser");

    return superuser ? children : <Navigate to="/login" />;
}

export default AdminRoute;